import React, { useCallback } from "react";
import { formatRupiah } from "@/lib/format";
import { Label } from "@/components/ui/label";
import { RupiahInput } from "@/components/RupiahInput";
import { CompanyPicker } from "@/components/SalesShared";

const num = (v) => Number(v) || 0;

export const payPartsBody = (f) => ({ cash_part: num(f.cash_part), transfer_part: num(f.transfer_part) });

export function payPartsError(f, amount, hideCompany) {
  const c = num(f.cash_part), t = num(f.transfer_part);
  if (f.pay_status === "split") {
    if (c <= 0 || t <= 0) return "Isi nominal Cash dan Transfer (keduanya lebih dari 0)";
    if (Math.abs(c + t - amount) > 0.001) return `Total Cash + Transfer (${formatRupiah(c + t)}) harus sama dengan jumlah tagihan (${formatRupiah(amount)})`;
  }
  if (f.pay_status === "kredit" && c + t > 0 && c + t >= amount) return "DP harus lebih kecil dari jumlah tagihan";
  const needAcc = f.pay_status === "transfer" || (["split", "kredit"].includes(f.pay_status) && t > 0);
  if (needAcc && !hideCompany && (!f.company_id || !f.account_number)) return "Pilih PT dan nomor rekening tujuan";
  return "";
}

export function PayPartsFields({ f, setF, companies, amount, testId, hideCompany }) {
  const setAcc = useCallback((v) => setF((p) => ({ ...p, account_number: v })), [setF]);
  const setCo = useCallback((v) => setF((p) => ({ ...p, company_id: v })), [setF]);
  const split = f.pay_status === "split";
  const kredit = f.pay_status === "kredit";
  if (!split && !kredit) return null;
  const c = num(f.cash_part), t = num(f.transfer_part);
  const setCash = (e) => {
    const v = e.target.value;
    setF((p) => ({ ...p, cash_part: v, ...(split && amount > 0 ? { transfer_part: String(Math.max(amount - num(v), 0)) } : {}) }));
  };
  const setTr = (e) => setF((p) => ({ ...p, transfer_part: e.target.value }));
  const diff = amount - c - t;
  return (
    <div className="rounded-lg border border-brand/20 bg-emerald-50/40 p-3 space-y-3" data-testid={`${testId}-parts`}>
      <p className="text-sm font-semibold text-brand">{split ? "Rincian Pembayaran Cash + Transfer" : "DP / Uang Muka (opsional)"}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div><Label className="text-xs">{split ? "Nominal Cash" : "DP Cash"}</Label><RupiahInput value={f.cash_part} onChange={setCash} placeholder="0" className="mt-1 font-mono" data-testid={`${testId}-cash-part`} /></div>
        <div><Label className="text-xs">{split ? "Nominal Transfer" : "DP Transfer"}</Label><RupiahInput value={f.transfer_part} onChange={setTr} placeholder="0" className="mt-1 font-mono" data-testid={`${testId}-transfer-part`} /></div>
      </div>
      {split ? (
        <p className={`text-xs ${Math.abs(diff) > 0.001 ? "text-rose-600" : "text-emerald-700"}`} data-testid={`${testId}-split-check`}>
          Total {formatRupiah(c + t)} dari {formatRupiah(amount)}{Math.abs(diff) > 0.001 ? ` · ${diff > 0 ? "kurang" : "lebih"} ${formatRupiah(Math.abs(diff))}` : " · sesuai"}
        </p>
      ) : (
        <p className="text-xs text-muted-foreground" data-testid={`${testId}-dp-summary`}>DP {formatRupiah(c + t)} · Sisa piutang <span className="font-mono font-semibold text-rose-600">{formatRupiah(Math.max(amount - c - t, 0))}</span></p>
      )}
      {(split || t > 0) && !hideCompany && <CompanyPicker companies={companies} value={f.company_id} onChange={setCo} account={f.account_number} onAccountChange={setAcc} testId={`${testId}-company`} />}
    </div>
  );
}
